// Helper to select data from lists... etc...
import Moment from 'moment'

export const getFormattedDate = (date: Date | null | undefined) => {
  if (!date) return 'None'
  return Moment(date).format('MM/DD/YY')
}
